import { ClientConfig } from '../config/ClientConfig'
import { observeAjax } from '../communication/ajax-helpers'
import { Injectable } from '../injector'
import { personalInfoUpdateRequested } from '../redux/cashier/UserActions'
import { UserApiService } from './UserApiService'
import { map } from 'rxjs/operators'

@Injectable()
export class UserService extends UserApiService {

	getUserBalance(): Promise<Balance> {
		return this.httpGet('/user/balance/XSD').toPromise()
	}

	getUserInfo(): Promise<UserInfo> {
		return this.httpGet('/user/info').toPromise()
	}

	getUserIdVerificationStatus(): Promise<IdVerificationStatusResponse> {
		return this.httpGet(`/id-verification/status`).toPromise()
	}

	/**
     * Calling the observeAjax instead of the UserApiService base methods, for we don't need to parse the
     * response for this API call.
     */
	async logout() {
		await observeAjax(ClientConfig.USERAPI_BASE_URL + '/user/logout',
			{
				method: 'GET',
				xhrFields: {
					withCredentials: true
				},
			}).toPromise()
	}

	getPersonalInfo(): Promise<PersonalInfo> {
		return this.httpGet('/user/personal-information').pipe(map(mapFromApiModel)).toPromise()
	}

	updatePersonalInfo(req: PersonalInfo): Promise<{}> {
		personalInfoUpdateRequested()
		return this.httpPost('/user/personal-information', mapToApiModel(req), { dataType: undefined }).toPromise()
	}

	confirmLogin(sid: string): Promise<void> {
		return this.httpPost<{}, void>('/user/login-confirmation', { sessionId: sid }).toPromise()
	}

	createPurchaseLimits(limits: CreatePurchaseLimit[]): Promise<void> {
		return this.httpPost<any, void>('/user/purchase-limits', {limits}).toPromise()
	}
}

function mapFromApiModel(info: any): PersonalInfo {
	return info.dateOfBirth
		? { ...info, dateOfBirth: new Date(info.dateOfBirth) }
		: info
}

function mapToApiModel(info: PersonalInfo) {
	const epoch = Date.UTC(info.dateOfBirth.getFullYear(), info.dateOfBirth.getMonth(), info.dateOfBirth.getDate())
	return { ...info, dateOfBirth: epoch }
}
